import { Product } from '@mc/api'
import { getDefaultTierAsync } from './getDefaultTierAsync'
import { ProductsQueryParams } from './getTiersAsync'

let defaultSubscriptionPlan: Product

export const getDefaultSubscriptionPlanPropertiesAsync = async (
  refresh = false,
  params: ProductsQueryParams = {},
) => {
  if (!!defaultSubscriptionPlan && !refresh) {
    return Promise.resolve(defaultSubscriptionPlan)
  }

  // Warning: If you need to change default subscription plan,
  // make sure you want to change it in every place we're calling this function
  // i.e: @mc/core, @mc/gifting, @mc/free-trial, @mc/enterprise, some @mc/libs, etc.
  const { product } = await getDefaultTierAsync(refresh, params)
  defaultSubscriptionPlan = product

  return defaultSubscriptionPlan
}
